import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaUnderWaterApi = createApi({
    reducerPath: "core/measurement/groundwater",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementGroundwaterList"],
    endpoints: (builder) =>({
        measurementGroundWaterFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementGroundwaterList'],
            query: (query = '') => ({
                url: "core/measurement/groundwater" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementGroundWaterCreate: builder.mutation({
            invalidatesTags: ['measurementGroundwaterList'],
            query: (data)=>({url: "core/measurement/groundwater", method: "POST", data})
        }),
        measurementGroundWaterUpdate: builder.mutation({
            invalidatesTags: ['measurementGroundwaterList'],
            query: (data)=>({url: "/core/measurement/groundwater/"+data.id, method: "PUT", data})
        }),
    
        measurementGroundWaterDelete: builder.mutation({
            invalidatesTags: ['measurementGroundwaterList'],
            query: (id)=>({url: "/core/measurement/groundwater/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementGroundWaterFindAllQuery, useMeasurementGroundWaterCreateMutation, useMeasurementGroundWaterUpdateMutation, useMeasurementGroundWaterDeleteMutation } = meaUnderWaterApi;
export {meaUnderWaterApi};
